import React from 'react';
import PropTypes from 'prop-types';

import Popper from 'app/components/common/popper';
import Icon from 'app/components/common/icon';

const textTypes = ['heading1', 'heading2', 'heading3', 'heading4', 'paragraph', 'code_block'];
const textTypeLabelMap = {
  paragraph:  ['Text',      'Text'],
  heading1:   ['Heading 1', 'H1'],
  heading2:   ['Heading 2', 'H2'],
  heading3:   ['Heading 3', 'H3'],
  heading4:   ['Heading 4', 'H4'],
  code_block: ['Code',      'Code'],
};
const textTypeOpts = textTypes.map(tt => ({label: textTypeLabelMap[tt][0], selectedLabel: textTypeLabelMap[tt][1], value: tt}));

const textFormats = ['strong', 'em', 'code'];
const textFormatLabelMap = {
  strong: 'Bold',
  em: 'Italic',
  code: 'Code',
};
const textFormatOpts = textFormats.map(tf => ({label: textFormatLabelMap[tf], value: tf}));

class RteWysiwygMenu extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      focusedTab: null,
    };

    this.refMain = React.createRef();
    this.tabKeyRefMenuMap = {};
    this.timeoutUnhover = null;

    this.onMouseEnterTab = this.onMouseEnterTab.bind(this);
    this.onMouseLeaveTab = this.onMouseLeaveTab.bind(this);
    this.onMouseEnterMenu = this.onMouseEnterMenu.bind(this);
    this.onMouseLeaveMenu = this.onMouseLeaveMenu.bind(this);

    this.preventDefault = this.preventDefault.bind(this);
    this.onClickMenu = this.onClickMenu.bind(this);
  }

  getRefMenu(tabKey) {
    if (!this.tabKeyRefMenuMap[tabKey]) {
      this.tabKeyRefMenuMap[tabKey] = React.createRef();
    }
    return this.tabKeyRefMenuMap[tabKey];
  }

  get menuEls() {
    return Object.values(this.tabKeyRefMenuMap).map(ref => ref.current).filter(el => el);
  }

  get mainEl() {
    return this.refMain.current;
  }

  get els() {
    return [...this.menuEls, this.mainEl];
  }

  onMouseEnterTab(event) {
    const tabKey = event.target.closest('.rte-menu-tab').dataset.tabKey;
    this.setTab(tabKey);
  }
  onMouseLeaveTab(event) {
    const tabKey = event.target.closest('.rte-menu-tab').dataset.tabKey;
    this.clearTab(100, tabKey);
  }
  onMouseEnterMenu(event) {
    const tabKey = event.target.closest('.rte-menu-tab-menu').dataset.tabKey;
    this.setTab(tabKey);
  }
  onMouseLeaveMenu(event) {
    const tabKey = event.target.closest('.rte-menu-tab-menu').dataset.tabKey;
    this.clearTab();
  }
  clearTab(timeoutMs=0, tabKey) {
    if (!timeoutMs) return this.setState({focusedTab: null});
    clearTimeout(this.timeoutUnhover);
    this.timeoutUnhover = setTimeout(() => {
      this.setState({focusedTab: null})
    }, timeoutMs);
  }
  setTab(focusedTab) {
    clearTimeout(this.timeoutUnhover);
    this.setState({focusedTab});
  }

  preventDefault(event) {
    event.preventDefault();
  }

  onClickMenu() {
    this.clearTab();
  }

  renderTabMenu(tab) {
    if (!tab?.children?.length) return null;
    return (
      <div className="rte-menu-tab-menu" onMouseEnter={this.onMouseEnterMenu} onMouseLeave={this.onMouseLeaveMenu} data-tab-key={tab.key} onClick={this.onClickMenu} ref={this.getRefMenu(tab.key)}>
        {tab.children.map((item, i) => {
          const className = `rte-menu-tab-menu-btn ${item.active ? 'active' : ''} ${item.className || ''}`;
          const ItemIcon = item.icon;
          const isHeading = !item.onClick;
          return isHeading
            ? (
              <div key={i} className={`rte-menu-tab-menu-label ${item.className || ''}`} onMouseDown={this.preventDefault}>{item.label}</div>
            )
            : (
              <button key={i} className={className} onMouseDown={this.preventDefault} disabled={!!item.disabled} onClick={item.onClick}>
                {ItemIcon && <ItemIcon className="rte-menu-tab-menu-btn-icon" />}
                {item.label}
              </button>
            );
        })}
      </div>
    );
  }

  render() {
    const {menu} = this.props;
    const {focusedTab} = this.state;

    return (
      <div className="rte-menu" ref={this.refMain}>
        {menu.map((tab) => {
          const TabIcon = tab.icon;
          const isFocused = focusedTab === tab.key;
          const hasMenu = !!tab.children?.length;
          const className = `rte-menu-tab ${isFocused ? 'focused' : ''} ${tab.active ? 'active' : ''} ${hasMenu ? 'menu' : ''} ${tab.className || ''}`;
          const tabContent = (
            <button
              title={tab.title || ''}
              className={className}
              key={tab.key}
              data-tab-key={tab.key}
              disabled={!!tab.disabled}
              onClick={tab.onClick}
              onMouseDown={this.preventDefault}
              onMouseEnter={this.onMouseEnterTab}
              onMouseLeave={this.onMouseLeaveTab}
            >
              {TabIcon && <TabIcon className="rte-menu-tab-icon" />}
              {!!tab.label && <span className="rte-menu-tab-label">{tab.label}</span>}
              {hasMenu && <Icon.Caret direction="down" className="rte-menu-tab-caret" />}
            </button>
          );
          if (!hasMenu) return tabContent;

          return (
            <Popper key={tab.key} popType="menu" placement="bottom-start" isActive={isFocused} popContent={this.renderTabMenu(tab)} usePortal offsetDistance={0}>
              {tabContent}
            </Popper>
          );
        })}
      </div>
    );
  }

}

RteWysiwygMenu.propTypes = {
  menu: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
};
RteWysiwygMenu.defaultProps = {
};

export default RteWysiwygMenu;
